import React, { useState } from "react";

interface AdminModalProps {
  // Leave out to hide CSV export (Health Rush only needs to clear its ranking).
  csv?: () => string;
  filePrefix?: string;
  onClear: () => void;
  onClose: () => void;
}

// Operator menu: clear the ranking, and optionally export it as CSV first.
export default function AdminModal({ csv, filePrefix, onClear, onClose }: AdminModalProps) {
  const [confirming, setConfirming] = useState(false);

  const exportCsv = () => {
    if (!csv) return;
    const url = URL.createObjectURL(new Blob([csv()], { type: "text/csv;charset=utf-8" }));
    const link = document.createElement("a");
    link.href = url;
    link.download = `${filePrefix}-${new Date().toISOString().slice(0, 10)}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="ad-modal">
      <div className="ad-modal-box">
        {confirming ? (
          <>
            <p>Apagar a classificação?</p>
            <p className="ad-modal-note">
              Todos os nomes e resultados serão apagados definitivamente deste dispositivo.
              {csv ? " Se quiser guardá-los, exporte o CSV antes de apagar." : ""}
            </p>
            <div className="ad-modal-actions">
              {csv ? (
                <button className="ad-pill small" onClick={exportCsv}>
                  Exportar CSV
                </button>
              ) : null}
              <button
                className="ad-pill small danger"
                onClick={() => {
                  onClear();
                  onClose();
                }}>
                Apagar tudo
              </button>
              <button className="ad-pill outline small" onClick={() => setConfirming(false)}>
                Cancelar
              </button>
            </div>
          </>
        ) : (
          <>
            <p>Administração</p>
            <div className="ad-modal-actions">
              {csv ? (
                <button className="ad-pill small" onClick={exportCsv}>
                  Exportar CSV
                </button>
              ) : null}
              <button className="ad-pill small" onClick={() => setConfirming(true)}>
                Apagar classificação
              </button>
              <button className="ad-pill outline small" onClick={onClose}>
                Fechar
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
